import { render, staticRenderFns } from "./article-apply.vue?vue&type=template&id=b0ef0130&scoped=true&"
import script from "./article-apply.vue?vue&type=script&lang=js&"
export * from "./article-apply.vue?vue&type=script&lang=js&"
import style0 from "./article-apply.vue?vue&type=style&index=0&id=b0ef0130&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0ef0130",
  null
  
)

export default component.exports